<app-spinner [show]="showSpinner"></app-spinner>
<!-- Start Login Area -->
<section class="login-area">
    <div class="row m-0">
        <div class="col-lg-6 col-md-12 p-0">
            <div class="login-image">
                <img src="assets/img/login-bg.jpg" alt="image">
            </div>
        </div>

        <div class="col-lg-6 col-md-12 p-0">
            <div class="login-content">
                <div class="d-table">
                    <div class="d-table-cell">
                        <div class="login-form">
                            <div class="logo">
                                <a routerLink="/"><img src="assets/img/black-logo.png" alt="image"></a>
                            </div>

                            <h3>{{welcomeBack}}</h3>
                            <p>{{newUser}} <a [routerLink]="['/register']">{{signUp}}</a></p>

                            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                                <div class="form-group">
                                    <input type="email" placeholder="{{emailText}}" class="form-control" formControlName="email">
                                    <div *ngIf="email.invalid && (email.dirty || email.touched)"
                                        class="alert alert-danger">

                                        <div *ngIf="email.errors.required">
                                            Email is required.
                                        </div>
                                        <div *ngIf="email.invalid && !email.errors.required">
                                            Invalid email.
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <input type="{{isShow ? 'text' : 'password'}}" placeholder="{{passwordText}}" class="form-control"
                                        formControlName="password">
                                    <i
                                        class="bx"
                                        [ngClass]="isShow ? 'bx-hide' : 'bx-show'"
                                        (click)="isShow = !isShow"
                                        style="cursor: pointer;"
                                    ></i>
                                   
                                    <div *ngIf="password.invalid && (password.dirty || password.touched)"
                                        class="alert alert-danger">

                                        <div *ngIf="password.errors.required">
                                            Password is required.
                                        </div>
                                        <div *ngIf="password.errors.minlength">
                                            Password must be at least 6 characters long.
                                        </div>
                                    </div>
                                </div>

                               

                                <button type="submit" [ngClass]="{'disabled-button':loginForm.invalid}">{{login}}</button>

                                <div class="forgot-password">
                                    <a [routerLink]="['/forgot-password']">{{forgotPassword}}</a>
                                </div>

                                
                            </form>

                            <div class="connect-with-socials" style="margin-top:10px;">
                                <button id="facebook-button" (click)= "onLoginWithFacebook()" class="facebook"><i class='bx bxl-facebook'></i> {{connectFacebook}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Login Area -->